//import { init_drawer } from './_drawer.js';
import { init_showOnScroll } from './_show-on-scroll.js';
import { init_fadeAnimation } from './_fade-and-slide.js';
import { init_infinityLoop } from './_infinity-loop.js';

const init = () => {
  init_showOnScroll();
  init_fadeAnimation();
  init_infinityLoop();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    init();
  });
} else {
  init();
}